module.exports = __webpack_public_path__ + "media/images/entropic-c89812638b0a404873025e151bfa4b5e.png";